import { ColorInterface } from "@/Interfaces/ColorInterfaces"

export default [
  {
    "name": "lmv",
    "color": "#f59100"
  }
]
